import { AD_PLATFORM_TYPE } from '@/constants/Constants.js' ;

export const numFormat = (num = 0) => {
  // console.log(num,typeof num)
  // 接口可能返回未知，做一下处理。
  let resultValue;
  if (typeof num != 'undefined') {
    resultValue = num.toString().indexOf('.') !== -1 ? num.toLocaleString() : num.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
  } else {
    resultValue = '未知错误';
  }
  return resultValue;
};
// 将整数转化为小数
export const currencyFormat = (num = 0) => {
  num = num.toString().replace(/\$|\,/g, '');
  if (isNaN(num)) num = '0';
  const sign = num == (num = Math.abs(num));
  num = Math.floor(num * 100 + 0.50000000001);
  let cents = num % 100;
  num = Math.floor(num / 100).toString();
  if (cents < 10) cents = `0${cents}`;
  for (let i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) num = `${num.substring(0, num.length - (4 * i + 3))},${num.substring(num.length - (4 * i + 3))}`;
  return `${(sign ? '' : '-') + num}.${cents}`;
};
// 将小数变化整数
export const currencyFormatV2 = (num = 0, isCents) => {
  num = num.toString().replace(/\$|\,/g, '');
  if (isNaN(num)) num = '0';
  const sign = num == (num = Math.abs(num));
  num = Math.floor(num * 100 + 0.50000000001);
  let cents = num % 100;
  num = Math.floor(num / 100).toString();
  if (cents < 10) cents = `0${cents}`;
  for (let i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) num = `${num.substring(0, num.length - (4 * i + 3))},${num.substring(num.length - (4 * i + 3))}`;
  if (isCents) {
    return `${(sign ? '' : '-') + num}.${cents}`;
  }
  return (sign ? '' : '-') + num;
};

// 自动添加单位w(有单位时自动添加2位小数，小于w的，使用isCents控制是否小数位数)
//   @param {number} num 值
//   @param {number} isCents 小于w时，保留几位小数
export const currencyFormatUnit = (num = 0, isCents) => {
  if (num >= 10000) {
    return `${currencyFormatV2(num / 10000, 2)}w`;
  }
  return currencyFormatV2(num, isCents);
};

/**
 * @description 格式化 AgencyList，用于统一Select的展示
 * @param agencyList
 * @return {unknown[]}
 */
export function formatAgencyList(agencyList = []) {
  return (agencyList || []).map((v) => {
    if (v.ad_platform_type === AD_PLATFORM_TYPE.MP) {
      return {
        ...v,
        value: v.agency_uid,
        label: v.remark ? v.remark : `${v.agency_uid}(${v.spid})`,
      };
    }
    return {
      ...v,
      value: v.agency_uid,
      label: v.remark ? v.remark : v.agency_uid,
    };
  });
}

export default {
  currencyFormat,
  numFormat,
  currencyFormatV2,
  formatAgencyList,
};
